import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPensionConfig } from '../OnboardingPension/OnboardingPension.slice'
import DashboardUtmYearContainer from '../DashboardUtm/DashboardUtmYear.container'
import DashboardImmHistoryContainer from '../DashboardImm/DashboardImmHistory.container'
import {
  METHOD,
  normalizePensionMethod,
} from '../../config/settings/constants'
import {
  SectionHeader,
  SectionTitle,
  SectionDescription,
  Column,
  UtmPanel,
} from '../../pages/Dashboard.styles'

const currentYear = new Date().getFullYear()

/**
 * Left reference panel on the dashboard: UTM or IMM depending on pension method.
 * Hidden until the user completes the wizard (no config → method unknown).
 */
const DashboardReferenceColumn = () => {
  const dispatch = useDispatch()
  const { config, fetchStatus } = useSelector(
    (state) => state.adminPensionConfig
  )

  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(getPensionConfig())
    }
  }, [dispatch, fetchStatus])

  const configReady =
    fetchStatus === 'succeeded' || fetchStatus === 'failed'
  const hasMethod = Boolean(config?.method)

  // Don't guess UTM/IMM before onboarding is done.
  if (!configReady || !hasMethod) {
    return null
  }

  const method = normalizePensionMethod(config.method)
  const showImm = method === METHOD.IMM

  if (showImm) {
    return (
      <Column>
        <SectionHeader>
          <SectionTitle>
            Ingreso Mínimo Mensual (IMM) {currentYear}
          </SectionTitle>
          <SectionDescription>
            Valor oficial del sueldo mínimo. Tu pensión se reajusta cuando este
            monto cambia.
          </SectionDescription>
        </SectionHeader>
        <UtmPanel>
          <DashboardImmHistoryContainer />
        </UtmPanel>
      </Column>
    )
  }

  return (
    <Column>
      <SectionHeader>
        <SectionTitle>
          Unidad Tributaria Mensual (UTM) {currentYear}
        </SectionTitle>
        <SectionDescription>
          Valores oficiales publicados por el SII mes a mes.
        </SectionDescription>
      </SectionHeader>
      <UtmPanel>
        <DashboardUtmYearContainer />
      </UtmPanel>
    </Column>
  )
}

export default DashboardReferenceColumn
